<scaffold-dialog [title]="data.title||''">
  <div scaffoldDialogBody>
      <div #contentHolder [innerHTML]="data.content | safeHtml"></div>
  </div>
  <div scaffoldDialogButtons>
    <button nbButton status="neutral" (click)="dialogRef.close()">{{'close'| translation}}</button>
    <button nbButton status="primary" (click)="getPDF(data.content)">PDF</button>
  </div>
</scaffold-dialog>
